import { produce } from "immer";
import {
  FETCH_REVIEWS_REPLY,
  FETCH_REVIEWS_REPLY_SUCCESS,
  FETCH_REVIEWS_REPLY_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_REVIEWS_REPLY,
  ADD_REVIEWS_REPLY_SUCCESS,
  ADD_REVIEWS_REPLY_FAILURE,
  //
  EDIT_REVIEWS_REPLY,
  EDIT_REVIEWS_REPLY_SUCCESS,
  EDIT_REVIEWS_REPLY_FAILURE,
  //
  DELETE_REVIEWS_REPLY,
  DELETE_REVIEWS_REPLY_SUCCESS,
  DELETE_REVIEWS_REPLY_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingReviewsReply: false,
  ReviewsReply: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentReviewsReply: {},
  // Delete
  isDeleting: false,
};

const ReviewsReplyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_REVIEWS_REPLY:
        draft.isFetchingReviewsReply = true;
        draft.currentReviewsReply = {};
        break;
      case FETCH_REVIEWS_REPLY_SUCCESS:
        draft.isFetchingReviewsReply = false;
        draft.ReviewsReply = action.payload;
        break;
      case FETCH_REVIEWS_REPLY_FAILURE:
        draft.isFetchingReviewsReply = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentReviewsReply = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentReviewsReply = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_REVIEWS_REPLY:
        draft.isSubmitting = true;
        break;
      case ADD_REVIEWS_REPLY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_REVIEWS_REPLY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_REVIEWS_REPLY:
        draft.isSubmitting = true;
        break;
      case EDIT_REVIEWS_REPLY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_REVIEWS_REPLY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_REVIEWS_REPLY:
        draft.isDeleting = true;
        break;
      case DELETE_REVIEWS_REPLY_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_REVIEWS_REPLY_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ReviewsReplyReducer;
